export const ARTWORKS = [
  {
    id: "here-with-you",
    slug: "here-with-you",
    title: "Here With You",
    imgBase: "/images/art/here-with-you",
    imgWidth: 2000,
    imgHeight: 1541,
    widthCm: 122,
    heightCm: 90,
    medium: null,
    status: "available",
    artistNote: null,
    contextImage: null,
    detailImage: null,
    alt: "Here With You, original figurative painting by Anissa, 122 × 90 cm.",
  },
  {
    id: "reborn",
    slug: "reborn",
    title: "Reborn",
    imgBase: "/images/art/reborn",
    imgWidth: 2000,
    imgHeight: 1971,
    widthCm: 75.5,
    heightCm: 75.5,
    medium: null,
    status: "available",
    artistNote: null,
    contextImage: null,
    detailImage: null,
    alt: "Reborn, original figurative painting by Anissa, 75.5 × 75.5 cm.",
  },
  {
    id: "what-i-remember",
    slug: "what-i-remember",
    title: "What I Remember",
    imgBase: "/images/art/i-remember",
    imgWidth: 2000,
    imgHeight: 1459,
    widthCm: 122,
    heightCm: 90,
    medium: null,
    status: "available",
    artistNote: null,
    contextImage: null,
    detailImage: null,
    alt: "What I Remember, original figurative painting by Anissa, 122 × 90 cm.",
  },
];

export const getArtworkBySlug = (slug) => ARTWORKS.find((a) => a.slug === slug);

export const formatDimensions = (a) => `${a.widthCm} × ${a.heightCm} cm`;

export const artworkSrcSet = (a) =>
  `${a.imgBase}-800.webp 800w, ${a.imgBase}-1200.webp 1200w, ${a.imgBase}-1600.webp 1600w`;
